module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img70.120022e0.jpg";